/* OneTimeComponent.js */

"use strict";
const Renderer = require("./OneTimeRenderer");
const BaseScheduleComponent = require("../../base/BaseScheduleComponent");

class OneTimeComponent extends BaseScheduleComponent {
    constructor(scheduleComp) {
        super(Renderer, scheduleComp);
    }
    static defaultValue() {
        let next = this.getNextFiveMinuteTimeFromNow();
        return {
            type: "one",
            tz: Intl.DateTimeFormat().resolvedOptions().timeZone,
            on: {
                year: next.getFullYear(),
                month: next.getMonth(),
                date: next.getDate(),
                hour: next.getHours(),
                minute: next.getMinutes(),
            },
        };
    }
}
module.exports = OneTimeComponent;
